var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-menu-divider',_vm._b({},'a-menu-divider',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }